module.exports = __webpack_public_path__ + "static/media/trades.27532e13.svg";